export default [
    {
        path: 'reportsystem',
        meta: {
            title: '报表管理'
        },
        component: () => import('../pages/report/SystemManage.vue'),
    },
    {
        path: 'reportdesignersystemlst',
        name: 'reportdesignersystemlst',
        meta: {
            title: '报表开发'
        },
        component: () => import('../pages/report/ReportDesignerSystemList.vue'),
    },
    {
        path: 'reportdesignerreportlist',
        name: 'reportdesignerreportlist',
        meta: {
            title: '报表开发'
        },
        component: () => import('../pages/report/ReportDesignerReportList.vue'),
    },
    {
        path: 'watermark',
        name: 'watermark',
        meta: {
            title: '报表开发'
        },
        component: () => import('../pages/report/ReportWaterMark.vue'),
    }

]
